import React from 'react'
import { FormGroup, Label, Button } from 'reactstrap'

function InstancesRefreshButton({ onRefresh, label = 'Actualizar' }) {
  return (
    <FormGroup className="page-size-control">
      <Label className="page-size-label">{label}</Label>
      <Button type="button" className="btn-card-primary w-100" onClick={onRefresh}>
        {label}
      </Button>
    </FormGroup>
  )
}

export default InstancesRefreshButton
